import { apiFetch, apiRequest } from '@/api/client'
import { createWorkspaceResourceApi } from '@/api/endpoints/workspaceResource'

const employees = createWorkspaceResourceApi('employees')
const multipart = { 'Content-Type': 'multipart/form-data' }
const workspace = (workspaceId) => `workspaces/${workspaceId}`

export const employeesApi = {
  list: employees.list,
  get: employees.get,
  remove: employees.remove,
  resendInvitation: (workspaceId, id) => employees.action(workspaceId, id, 'resend'),
  sendRenewalEmail: (workspaceId, id) => employees.action(workspaceId, id, 'renewal-email'),
  addReview: (workspaceId, id, payload) =>
    apiFetch(`${employees.path(workspaceId)}/${id}/status`, {
      method: 'PUT',
      body: { ...payload, _methods: 'PUT' },
    }),
  invite: (workspaceId, payload) => apiFetch(`${employees.path(workspaceId)}/invite`, { method: 'POST', body: payload }),
  runAiAnalysis: (workspaceId, id, payload) => employees.action(workspaceId, id, 'ai-analysis', payload),
  create: (workspaceId, payload) =>
    apiFetch(employees.path(workspaceId), { method: 'POST', body: payload, headers: multipart }),
  // Laravel method spoofing, kept as the backend expects it.
  update: (workspaceId, id, payload) =>
    apiFetch(`${employees.path(workspaceId)}/${id}`, {
      method: 'POST',
      body: { ...payload, _method: 'PUT' },
      headers: multipart,
    }),
  generateReport: (workspaceId, id) => employees.action(workspaceId, id, 'report'),
  uploadDocument: (workspaceId, employeeId, payload) =>
    apiFetch(`${employees.path(workspaceId)}/${employeeId}/documents`, {
      method: 'POST',
      body: payload,
      headers: multipart,
    }),
  assignDocument: (workspaceId, employeeId, payload) =>
    apiFetch(`${employees.path(workspaceId)}/${employeeId}/documents/assign`, {
      method: 'POST',
      body: payload,
      ignoreGlobalCatch: true,
    }),
  /** Resolves the full response (Blob in `data`). */
  downloadDocument: (workspaceId, documentId) =>
    apiRequest(`${employees.path(workspaceId)}/documents/${documentId}/download`, {
      responseType: 'blob',
      ignoreGlobalCatch: true,
    }),

  // AML screening
  screenAml: (workspaceId, payload) =>
    apiFetch(`${workspace(workspaceId)}/risks/aml/screen`, { method: 'POST', body: payload }),
  updateAmlCase: (workspaceId, amlId, payload) =>
    apiFetch(`${workspace(workspaceId)}/risks/aml/cases/${amlId}`, { method: 'PUT', body: payload }),

  // Public employee onboarding (token link, no workspace)
  onboardingForm: (token) => apiFetch(`employee-onboarding/${token}`),
  submitOnboardingForm: (token, payload) =>
    apiFetch(`employee-onboarding/${token}`, { method: 'POST', body: payload, headers: multipart }),
}
